// extracted by mini-css-extract-plugin
export default {"accordion_wrapper":"cr","accordion_header":"er","accordion_title":"fr","accordion_collapse_button":"gr","accordion_body":"hr","accordion_wrapper_opened":"ir","accordion_v2":"jr"};
    if(module.hot) {
      // 1715632474819
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  